import { Button } from './Button';
import { Modal } from './Modal';

export interface ConfirmDialogProps {
  title: string;
  description?: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  /** 'danger' styles the confirm action as destructive (delete/archive/deactivate/cancel). */
  variant?: 'default' | 'danger';
  /** Disables both buttons and shows a spinner on the confirm button while a mutation is in flight. */
  isLoading?: boolean;
}

/**
 * ConfirmDialog — shared "are you sure?" prompt for destructive or otherwise
 * hard-to-reverse actions (sign out, delete, cancel, archive, merge, deactivate).
 * Built on the shared `Modal` shell; closing it (Escape/backdrop/close button)
 * is treated the same as Cancel.
 */
export function ConfirmDialog({
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  variant = 'danger',
  isLoading = false,
}: ConfirmDialogProps) {
  return (
    <Modal
      title={title}
      description={description}
      onClose={onCancel}
      footer={
        <>
          <Button type="button" variant="ghost" fullWidth onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant={variant === 'danger' ? 'danger' : 'primary'}
            fullWidth
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {null}
    </Modal>
  );
}
